import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { MyPromise } from './interceptors/myPromise.service';

const APIURL = `${environment.baseEndpoint}/employees`;

@Injectable({
  providedIn: 'root',
})
export class EmployeeService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise,
  ) { }

  getEmployees(stationId) {
    return this.myPromise.to(this.http.get(`${APIURL}/${stationId}`));
  }

  storeEmployee(stationId, user) {
    return this.myPromise.to(this.http.post(`${APIURL}/${stationId}`, user));
  }

  deleteEmployee(stationId, userId) {
    return this.myPromise.to(this.http.delete(`${APIURL}/${stationId}/${userId}`));
  }

  updateEmployee(stationId, user) {
    return this.myPromise.to(this.http.put(`${APIURL}/${stationId}/${user.id}`, user));
  }
}
